// extracted by mini-css-extract-plugin
export default {"host":"DisclosureSelection_host__C53Tq"};